module.exports = __webpack_public_path__ + "assets/images/cosmote_highlights.00fdb90c2d3f78e5c3667709ddc11a1a.png";